// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"227":"ba01e08f","310":"beef7745"}[chunkId] + ".css";
};